// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ef-div:hover > .card-admin {\n  transform: translateY(-10px);\n}\n\n.card-admin {\n  box-shadow: 0px 5px 12px 2px rgba(163, 163, 163, 0.23);\n  transition: transform 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);\n}\n\n.icon-cards {\n  font-size: 10rem;\n}\n\n.edit-btn {\n  --border-width: 1px;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
